<template>
  <div>
    <div v-if="visible" class="rp-dialog" :style="{ 'z-index': zIndex }">
      <div class="el-dialog" style="width:100%;margin:0">
        <div class="el-dialog__header">
          <span>
            <span style="font-size:16px">{{ titleMap[step] }}</span>
            <span v-show="step == 3" style="font-size:12px;color:#e67702"
              >（如果没有时间，可以发送给数据同事帮忙制作）</span
            >
          </span>
          <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="close" style="top:23px">
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
        <div class="el-dialog__body">
          <div class="rp-name">
          {{ radish.姓名 }}
          </div>
          <div class="rp-steps">
            <div class="rp-step" :class="{ 'rp-step-active': step == 1 }">选择简历</div>
            <div class="rp-step" :class="{ 'rp-step-active': step == 2 }">选择项目</div>
            <div class="rp-step" :class="{ 'rp-step-active': step == 3 }">选择制作方式</div>
          </div>
          <ReportReference v-show="step == 1" ref="ReportReference" @selectItem="selectFile" @next="next" />
          <ProjectSelect v-show="step == 2" ref="ProjectSelect" @selectItem="selectProject" @next="next" />
          <TemplateChoose
            v-show="step == 3"
            ref="TemplateChoose"
            @selectItem="selectSpTemplate"
            @chooseMaker="chooseMaker"
            @chooseTemplateType="chooseTemplateType"
            @inputRemark="inputRemark"
          />
          <div style="display:flex;justify-content: center;margin-top:10px">
            <div v-if="step == 1" class="morandi-btn-outline" style="margin-right:10px" @click="visible = false">
              取消
            </div>
            <div v-if="step > 1" class="morandi-btn-outline" style="margin-right:10px" @click="prev">上一步</div>
            <div v-if="step < 3" class="morandi-btn" @click="next">下一步</div>
            <div v-if="step == 3" class="morandi-btn" @click="make">开始制作</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportReference from './ReportReference.vue'
import ProjectSelect from './ProjectSelect'
import TemplateChoose from './TemplateChoose'

export default {
  components: {
    ReportReference,
    ProjectSelect,
    TemplateChoose,
  },
  data() {
    return {
      radish: {},
      project: {},
      file: {},
      spTemplate: {},
      templateType: '',
      maker: '',
      remark: '',
      visible: false,
      step: 1,
      titleMap: {
        1: '制作推荐报告',
        2: '选择项目',
        3: '制作者选择及制作模版',
      },
      zIndex: 1000,
    }
  },
  computed: {
    account() {
      return window.app.user.account
    },
    pid() {
      return this.$route.params.projectId
    },
  },
  methods: {
    async init({ project, radish, file }) {
      console.log('int', { project, radish, file })
      this.radish = {}
      this.file = file || {}
      this.project = {}
      try {
        if (typeof project === 'string' || this.pid) {
          this.project = await window.app.service('project').fetch(project || this.pid)
        } else if (typeof project === 'object') {
          this.project = Object.assign({}, project)
        }
        const { data } = await window.app.service('radish').fetch({ _id: radish })
        let analyseRes = {}
        if (file) {
          try {
            analyseRes = await window.app.service('file').analyse(file)
          } catch (e) {
            console.error(e)
          }
        }
        this.zIndex = app.root.dragindex++
        this.radish = Object.assign({}, data && data[0], analyseRes)
        this.visible = true
        this.step = 1
        this.$nextTick(() => {
          this.$refs.ReportReference.init({ radish: this.radish, defaultSelectedFile: file })
        })
      } catch (error) {
        console.error(error)
      }
    },
    close() {
      this.visible = false
      window.app.root.$refs.cvPreview.close()
    },
    async sendToOther() {
      const { file, project, radish, spTemplate, remark, templateType } = this

      const params = {
        _id: file.fileId || file._id,
        md5: file.md5,
        originalname: file.originalname,
        pid: project._id,
        rid: radish._id,
        name: radish['姓名'],
        company: project['客户公司'],
        department: project['部门'],
        project: project['项目名称'],
        templateType,
        remark,
        spTemplate,
        sender: this.account,
        createdAt: Date.now()
      }
      try {
        await window.app.service('recommendReport').create(params)
        this.$message({ type: 'success', message: `消息已发送` })
      } catch (e) {
        this.$message.error((e.response && e.response.message) || e.message)
      }
    },
    async chooseSelf() {
      let fileData
      try {
        fileData = await window.app.root.$refs.cvPreview.getFile(this.file, {
          showHighlight: true,
          rid: this.radish._id,
          pid: this.project._id,
          width: '43vw',
        })
      } catch (e) {
        this.$message.error(e.message)
        console.error(e)
      }
      app.root.$refs.ReportTemplateV2.init({
        rid: this.radish._id,
        pid: this.project._id,
        md5: this.file.md5,
        templateId: this.spTemplate._id || '',
        fileData,
      })
    },
    selectFile(file) {
      this.file = file
    },
    selectProject(project) {
      this.project = project
    },
    selectSpTemplate(template) {
      this.spTemplate = template
    },
    chooseMaker(maker) {
      this.maker = maker
    },
    chooseTemplateType(tmp) {
      this.templateType = tmp
    },
    inputRemark(remark) {
      this.remark = remark
    },
    next() {
      if (this.step == 1) {
        if (!this.file.md5) return this.$message('请选择一份简历')
        this.step = 2
        this.$nextTick(() => {
          this.$refs.ProjectSelect.init({
            rid: this.radish._id,
            defaultSelectProject: this.project._id ? this.project : null,
          })
        })
      } else if (this.step == 2) {
        if (!this.project._id) return this.$message('请选择一个项目')
        if (!this.project.rid) {
          this.$confirm(
            `【${
              this.project.项目名称
            }】非候选人参与的项目，如果选择用此项目制作推荐报告，系统会自动把候选人加入该项目`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            },
          )
            .then(() => {
              this.step = 3
              this.$nextTick(() => {
                this.$refs.TemplateChoose.init({ companyName: this.project.客户公司 })
              })
            })
            .catch(() => {})
        } else {
          this.step = 3
          this.$nextTick(() => {
            this.$refs.TemplateChoose.init({ companyName: this.project.客户公司 })
          })
        }
      }
    },
    prev() {
      this.step = this.step - 1
    },
    async make() {
      if (!this.maker) return this.$message('请选择制作者')
      if (this.templateType == 'special' && !this.spTemplate.md5) return this.$message('请选择模板')
      // 加入项目
      await app.service('radish').intoProject({ rid: this.radish._id, pid: this.project._id })
      this.$alert('制作推荐报告不会把人选在项目中推荐，请自行推荐', '温馨提示', {
        confirmButtonText: '知道了',
        showClose: false,
        callback: action => {
          if (this.maker == 'other') {
            this.sendToOther()
          } else {
            this.chooseSelf()
          }
          this.visible = false
        }
      });

    },
  },
}
</script>
<style>
.rp-dialog {
  position: fixed;
  top: 5px;
  right: 20%;
  bottom: 0;
  left: 20%;
  overflow: auto;
  margin: 0;
}
.rp-steps {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin: 10px 40px 20px 0;
}
.rp-step {
  position: relative;
  color: #fff;
  background-color: #d8d8d8;
  text-align: center;
  padding: 0 20px 0 25px;
  height: 29px;
  line-height: 29px;
  width: 200px;
}
.rp-step.rp-step-active {
  background-color: #afc7db;
}
.rp-step::after {
  content: '';
  position: absolute;
  right: -10px;
  top: 4px;
  width: 20px;
  height: 20px;
  background-color: inherit;
  transform: rotate(45deg);
}
.rp-steps::before {
  content: '';
  width: 100%;
  border-top: 1px solid #d8d8d8;
  position: absolute;
  top: 14px;
}
.rp-dialog .el-dialog__body {
  padding: 20px;
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
.rp-dialog .el-dialog__header {
  border: 1px solid #eee;
  padding-bottom: 20px;
  color: #333;
}
.rp-a-link {
  color: #2478b5;
  cursor: pointer;
}
.rp-dialog .el-dialog__headerbtn .el-dialog__close:hover {
  color: #467eab;
}
.rp-name {
  font-size: 20px;
  text-align: center;
  margin-bottom: 5px;
  font-weight: bold;
  color: #2478b5;
  display: inline-block;
  position: relative;
  padding-left: 15px;
  transform: skewX(-10deg);
}
.rp-name::before,.rp-name::after {
  content: '';
  width: 4px;
  height: 20px;
  background-color: #2478b5;
  position: absolute;
  left: 0;
  bottom: 4px;
}
.rp-name::after {
  left: 5px;
}
</style>
